import React, { useCallback, useEffect, useState } from 'react';
// import { Button } from 'antd';
import ToolBar from '../../../components/ToolBar';
import ListTable from './components/ListTable';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import { fetchListProvider } from '../../../store/ProviderSlice';
import AddProvider from './components/AddProvider';

const Providers: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);

  const getList = useCallback((data?: any) => {
    setTableLoading(true);
    const payload = {
      ...data,
      current: data?.current ?? paginationData?.current ?? 1,
      page_size: data?.page_size ?? paginationData?.page_size ?? 10,
    };
    setSavePayload(payload);
    dispatch(fetchListProvider(payload))
      .then((res: any) => {
        //console.log('res?.data', res?.data);

        setListData(res?.data);
        setTotalData(res?.total_data);
        setTableLoading(false);
      })
      .catch(() => {
        setListData([]);
        setTotalData(0)
        setTableLoading(false);
      });
  }, [dispatch, paginationData]);

  useEffect(() => {
    getList();
  }, [getList]);

  const handleAddModal = () => {
    setOpenAddModal(!openAddModal);
  };

  return (
    <>
      <ToolBar
        title={'Portability Providers'}
        // children={
        //   <>
        //     <Button
        //       type="primary"
        //       onClick={handleAddModal}
        //     >
        //       Add New
        //     </Button>
        //   </>
        // }
      />
      <ListTable
        listData={listData}
        setListData={setListData}
        totalData={totalData}
        tableloading={tableloading}
        setTableLoading={setTableLoading}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        getList={getList}
        savePayload={savePayload}
      />

      {openAddModal ? (
        <AddProvider
          handleAddModal={handleAddModal}
          openAddModal={openAddModal}
          getList={getList}
        />
      ) : null}
    </>
  );
};
export default Providers;
